import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

// Applies site-wide branding: favicon, document title, primary/secondary CSS variables,
// and provides announcement banner data via a global window event.
export default function ThemeApplier() {
  const location = useLocation();

  const apply = async () => {
    try {
      const { data } = await api.get("/settings");
      // Document title
      if (data.site_title) document.title = data.site_title;
      // Favicon
      if (data.favicon_url) {
        let link = document.querySelector("link[rel='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.href = data.favicon_url;
      }
      // Meta description
      if (data.seo_description) {
        let m = document.querySelector("meta[name='description']");
        if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
        m.content = data.seo_description;
      }
      // CSS variables
      const root = document.documentElement;
      if (data.primary_color) root.style.setProperty("--brand-primary", data.primary_color);
      else root.style.removeProperty("--brand-primary");
      if (data.secondary_color) root.style.setProperty("--brand-secondary", data.secondary_color);
      else root.style.removeProperty("--brand-secondary");
      if (data.accent_color) root.style.setProperty("--brand-accent", data.accent_color);
      else root.style.removeProperty("--brand-accent");
      // Store settings in window for other components to read
      window.__siteSettings = data;
      // Cache the branding-relevant fields so the pre-boot script in index.html
      // can apply them synchronously on the NEXT page load (kills the flicker).
      try {
        const cache = {
          primary_color: data.primary_color || null,
          secondary_color: data.secondary_color || null,
          accent_color: data.accent_color || null,
          site_title: data.site_title || null,
          favicon_url: data.favicon_url || null,
          seo_description: data.seo_description || null,
        };
        localStorage.setItem("siteBranding", JSON.stringify(cache));
      } catch (e) { /* storage quota or private mode */ }
      window.dispatchEvent(new CustomEvent("site-settings-loaded", { detail: data }));
    } catch (e) { /* ignore */ }
  };

  useEffect(() => { apply(); }, [location.pathname]);
  useEffect(() => {
    const h = () => apply();
    window.addEventListener("settings-updated", h);
    return () => window.removeEventListener("settings-updated", h);
  }, []);

  return null;
}
